import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function usePoll(url, ms = 5000, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const alive = useRef(true);
  const load = useCallback(async () => {
    try {
      const r = await api.get(url);
      if (alive.current) {
        setData(r.data);
        setError(null);
      }
    } catch (e) {
      if (alive.current) setError(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    alive.current = true;
    load();
    const id = ms ? setInterval(load, ms) : null;
    return () => {
      alive.current = false;
      if (id) clearInterval(id);
    };
  }, [load, ms]);
  return { data, error, reload: load };
}
